import { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'
import styled from 'styled-components'
import { Text } from '../../../../../elements/typography'
import messages from '../../../messages'
import { FeaturedActorCard } from './FeaturedActorCard'

const Container = styled(View)`
  margin: 0 auto 0 ${(props) => props.theme.spacing.md}px;
`

const List = styled(View)`
  flex-direction: row;
  align-items: stretch;
  margin-left: ${(props) => props.theme.spacing.xs}px;
`

const Title = styled(Text)`
  margin-bottom: ${(props) => props.theme.spacing.md}px;
  font-size: ${(props) => props.theme.fontSizes.xlarge}px;
`

const FeaturedActorList = memo(
  ({ actors = [], onActorSelect }) =>
    actors.length > 0 && (
      <Container>
        <Title>
          <FormattedMessage {...messages.featuredActors} />
        </Title>

        <List>
          {actors.slice(0, 8).map(({ posterImg, ...actorProps }) => (
            <FeaturedActorCard
              {...actorProps}
              key={actorProps.slug}
              publicId={posterImg}
              onActorSelect={onActorSelect}
            />
          ))}
        </List>
      </Container>
    ),
)

export default FeaturedActorList
